import {
  IntegrationLogEventPublishReq,
  IntegrationLogResponse,
} from '@monetize/types/app';
import { useCallback } from 'react';
import { useSyncLogPublish } from '../api/settingsService';
import { useToast } from '../services/toast';

export function useIntegrationLogResync({
  closeDetailModal,
}: {
  closeDetailModal: () => void;
}) {
  const { addToast } = useToast();

  const syncLogPublishMutation = useSyncLogPublish({
    onSuccess: (data) => {
      addToast({
        summary: 'Success',
        detail: data.message,
        severity: 'success',
      });
      closeDetailModal();
    },
    meta: { showErrorToast: true },
  });

  const resyncLog = useCallback(
    (logItem: IntegrationLogResponse) => {
      const payload: IntegrationLogEventPublishReq = {
        id: logItem.sourceId,
        entityType: logItem.entityName,
        action: logItem.eventType,
      };

      syncLogPublishMutation.mutate(payload);
    },
    [syncLogPublishMutation],
  );

  return {
    resyncLog,
    isLoading: syncLogPublishMutation.isPending,
    isSuccess: syncLogPublishMutation.isSuccess,
    isError: syncLogPublishMutation.isError,
    error: syncLogPublishMutation.error,
  };
}
